import React from "react";
import { Container, Text, withStyles } from "components/common";
import shareLink from "assets/share-link.svg";
import yourFriend from "assets/your-friend.svg";
import tool from "assets/tool.svg";
import connector from "assets/connector.svg";
import { compose } from "redux";
import { connect } from "react-redux";

const list = (type) => [
  {
    text: "Share your referral link with your friends, family, and followers.",
    icon: shareLink,
    id: 0,
  },
  {
    text:
      type === "ambassador"
        ? "For every applicant approved, you get an extra 1%."
        : "Once 2 of them sign up and get approved, you'll receive a bonus 1% cashback*",
    icon: yourFriend,
    id: 1,
  },
  {
    text:
      type === "ambassador"
        ? "Keep referring and earn up to 20% cashback! Referrals are unlimited. Earn up to $500 in cashback each month."
        : "That's it! Now you have 2% cashback for a year",
    icon: tool,
    id: 2,
  },
];

const InviteFriends = ({ roles }) => (
  <Container
    paddingHorizontal={32}
    className="w-full flex justify-center py-10"
  >
    <Text
      title
      className="mb-8 text-2xl md:text-3xl"
    >{`Boost your cashback up to ${roles.ambassador ? "20%" : "2%"}`}</Text>
    {list(roles.ambassador && "ambassador").map((item, index) => (
      <div key={item.id}>
        {!!index && (
          <img src={connector} style={{ marginLeft: "28px" }} alt="connector" />
        )}
        <div className="flex items-center">
          <img
            className="mr-4"
            src={item.icon}
            alt="icon"
            style={{ width: "53px" }}
          />
          <div className="flex">
            <Text weight="font-bold" className="text-green-primary mr-2">{`${
              index + 1
            }.`}</Text>
            <Text>{item.text}</Text>
          </div>
        </div>
      </div>
    ))}
  </Container>
);

export default compose(
  connect((state) => ({
    roles: state.user.roles,
  })),
  withStyles,
)(InviteFriends);
